<template>
  <Header/>
  <div id="main" class="width">
    <LeftSide/>

    <div class="nright" style="margin-top: 10px;">
      <div class="article">
        <h1>{{ detail.post_title }}</h1>
        <div class="article_info"><span>时间：{{ detail.post_date }}</span></div>
        <div class="content" v-html="detail.post_content">
        </div>

        <div class="context">
          <span v-if="left" class="prevrecord">上一条：
            <a :href="'/#/detail?id=' + left.ID">
              {{ left.post_title }}
            </a>
          </span>

          <span v-if="right" class="prevrecord">下一条：
              <a :href="'/#/detail?id=' + right.ID">
              {{ right.post_title }}
            </a>
          </span>
        </div>

        <div class="relevant box">
          <h3 class="title"><strong>相关文章</strong></h3>
          <ul class="rel_content">

            <li v-for="(item, index) in related" :key="index">
              <span>[{{ item.post_date.split(" ")[0] }}]</span>
              <a :href="'/#/detail?id=' + item.ID" target='_blank'
                 :title='item.post_title'>
                {{ item.post_title }}
              </a>
            </li>

            <div style="clear: both"></div>
          </ul>
        </div>

      </div>
    </div>
  </div>
  <Footer/>
</template>

<script>
import Footer from "@/components/Footer"
import Header from "@/components/Header"
import LeftSide from "@/components/LeftSide"
import http from "@/util/http"

export default {
  name: "DetailPage",
  components: {LeftSide, Footer, Header},
  data() {
    return {
      right: undefined,
      left: undefined,
      detail: {},
      related: []
    }
  },
  mounted() {
    this._getDetail()
    this._getRelated()
  },
  methods: {
    _getDetail() {
      http.get('articleDetail', {
        id: this.$route.query.id
      })
          .then((res) => {
            if (res.data.status === 0) {
              this.detail = res.data.data
              // this._domTitle()
            }
          })
    },
    _getRelated() {
      http.get('relatedArticle', {
        id: this.$route.query.id
      })
          .then((res) => {
            if (res.data.status === 0) {
              this.related = res.data.data.related
              this.right = res.data.data.right.length > 0 ? res.data.data.right[0] : undefined
              this.left = res.data.data.left.length > 0 ? res.data.data.left[0] : undefined
            }
          })
    }
  }
}
</script>

<style scoped>
li {
  line-height: 1.5;
}
.content >>> td {
  border: 1px solid #000000;
}
</style>